import {
  CONFIRMED_GET_LEADS,
  CONFIRMED_GET_TELECALLER_LIST,
  ASSIGN_LEADS_REQUEST,
  ASSIGN_LEADS_SUCCESS,
  ASSIGN_LEADS_FAILURE,
  CONFIRMED_GET_LEAD_DETAILS,
  CONFIRMED_DELETE_LEAD_ACTION,
  CONFIRMED_CREATE_LEAD_ACTION,
  CONFIRMED_ADD_LEAD_MARRIAGE_INFO,
  CONFIRMED_ADD_LEAD_ADDRESS_INFO,
  CONFIRMED_ADD_LEAD_OTHER_INFO,
  CONFIRMED_EDIT_LEAD_ACTION,
  ADD_APPOINTMENT_TO_LEAD,
  UPDATE_APPOINTMENT_IN_LEAD,
  REMOVE_APPOINTMENT_FROM_LEAD,
} from "./LeadType";

import {
  formatLeads,
  getLeads,
  getTelecallerlist,
  formatTelecallers,
  assignLeadsToTelecaller,
  getLeadDetails,
  deleteLead,
  createLead,
  addLeadMarriageInfo,
  addLeadAddressInfo,
  addLeadOtherInfo,
  updateLead,
} from "../../services/LeadService";

import {
  handleSuccess,
  showErrorAlert,
} from "../../services/ErrorHandlingService";

import axios from "axios";
import axiosInstance from "../../services/AxiosInstance";

// Get token from Redux or fallback to localStorage
function getAuthToken(getState) {
  const stateToken = getState().auth?.authKey;
  if (stateToken) return stateToken;

  const storedUser = localStorage.getItem("userDetails");
  return storedUser ? JSON.parse(storedUser).token : null;
}

// export function getLeadsAction(
//   pagination = false,
//   pageid = 0,
//   status = "Not Converted"
//   , search_by = "", search_keyword = "",sort_by="",sort_order=""
// ) {
//   return async (dispatch) => {
//     try {
//       const response = await getLeads(pagination, pageid, status, search_by, search_keyword,sort_by,sort_order);

//       if (response && response.status === 200 && response.data) {
//         if (response.data.status === "success" && response.data.data) {
//           const leads = formatLeads(response.data.data);
//           dispatch({ type: CONFIRMED_GET_LEADS, payload: leads });
//         } else {
//           showErrorAlert("Failed to get leads: Server error");
//         }
//       } else {
//         showErrorAlert("Failed to get leads: Network error");
//       }
//     } catch (error) {
//       console.error("API Error:", error.response || error);
//       showErrorAlert("Failed to get leads");
//     }
//   };
// }
export function getLeadsAction(
  pagination = false,
  pageid = 0,
  status = "All",
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return async (dispatch) => {
    try {
      const response = await getLeads(pagination, pageid, status, search_by, search_keyword, sort_by, sort_order);
      
      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const leads = formatLeads(response.data.data);
          dispatch({
            type: CONFIRMED_GET_LEADS,
            payload: {
              leads: leads,
              num_rows: response.data.num_rows || 0
            }
          });
        } else {
          showErrorAlert("Failed to get leads: Server error");
        }
      } else {
        showErrorAlert("Failed to get leads: Network error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get leads");
    }
  };
}


export function getTelecallerlistAction() {
  return async (dispatch) => {
    try {
      const response = await getTelecallerlist();

      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const telecallers = formatTelecallers(response.data.data);
          dispatch({
            type: CONFIRMED_GET_TELECALLER_LIST,
            payload: telecallers,
          });
        } else {
          showErrorAlert( "Failed to get telecaller: Server error");
        }
      } else {
        showErrorAlert( "Failed to get telecaller: Network error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert( "Failed to get telecaller");
    }
  };
}

// export const assignLeadsAction = (leadIds, telecallerId,isFreshLead = true) => {
//   return async (dispatch) => {
//     dispatch({ type: ASSIGN_LEADS_REQUEST });

//     try {
//       const payload = {
//         lead_ids: JSON.stringify(
//           Array.isArray(leadIds) ? leadIds : leadIds ? [leadIds] : []
//         ),
//         telecaller_id: telecallerId,
//         fresh_lead: isFreshLead ? "Yes" : "No",
//       };

//       const response = await assignLeadsToTelecaller(payload);

//       if (response?.data?.status === "success") {
//         dispatch({ type: ASSIGN_LEADS_SUCCESS });
//       } else {
//         dispatch({
//           type: ASSIGN_LEADS_FAILURE,
//           payload: response?.data?.message || "Failed",
//         });
//         showErrorAlert(
//           "Failed",
//           response?.data?.message || "Lead assignment failed"
//         );
//       }
//     } catch (error) {
//       dispatch({ type: ASSIGN_LEADS_FAILURE, payload: error.message });
//       console.error("Assignment error:", error);
//       showErrorAlert(
//         "Error",
//         error.message || "Something went wrong during lead assignment"
//       );
//     }
//   };
// };
export const assignLeadsAction = (leadIds, telecallerId, isFreshLead = true) => {
  return async (dispatch) => {
    dispatch({ type: ASSIGN_LEADS_REQUEST });

    try {
      const payload = {
        lead_ids: JSON.stringify(
          Array.isArray(leadIds) ? leadIds : leadIds ? [leadIds] : []
        ),
        telecaller_id: telecallerId,
        fresh_lead: isFreshLead ? "Yes" : "No",
      };

      const response = await assignLeadsToTelecaller(payload);

      if (response?.data?.status === "success") {
        dispatch({ type: ASSIGN_LEADS_SUCCESS });

        // ✅ RETURN RESPONSE
        return response.data;
      } else {
        dispatch({
          type: ASSIGN_LEADS_FAILURE,
          payload: response?.data?.message || "Failed",
        });

        throw new Error(response?.data?.message || "Lead assignment failed");
      }
    } catch (error) {
      dispatch({ type: ASSIGN_LEADS_FAILURE, payload: error.message });
      throw error;
    }
  };
};
export function getLeadDetailsAction(lead_id) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      const response = await getLeadDetails(lead_id);
      // console.log("API Response:", response)

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_LEAD_DETAILS,
          payload: response.data.data,
        });
      } else {
        showErrorAlert( "Failed to get lead details");
      }
    } catch (error) {
      console.error("API Error:", error);
      showErrorAlert( error.message || "Failed to get lead details");
    }
  };
}

export function deleteLeadAction(lead_id) {
  return async (dispatch) => {
    try {
      await deleteLead(lead_id);
      dispatch({
        type: CONFIRMED_DELETE_LEAD_ACTION,
        payload: { lead_id },
      });
      handleSuccess("Lead deleted successfully!");
      return true;
    } catch (error) {
      console.error(error);
      showErrorAlert( "Failed to delete lead");
      throw error;
    }
  };
}

// Create Lead
export function createLeadAction(formData) {
  return async (dispatch) => {
    try {
      const leadData = {
        first_name: formData.first_name,
        middile_name: formData.middle_name || "",
        last_name: formData.last_name,
        email: formData.patient_email || "",
        whatsapp_contact_no: formData.whatsapp_contact_no,
        additional_contact_no: formData.additional_contact_no || "",
        gender: formData.gender,
        date_of_birth: formData.date_of_birth,
        height: formData.height || "",
        weight: formData.weight || "",
        occupation: formData.occupation || "",
        id_proof: formData.id_proof || "",
        id_number: formData.id_number || "",
        disease_ids: JSON.stringify(
          Array.isArray(formData.disease_names)
            ? formData.disease_names
            : formData.disease_names
            ? [formData.disease_names]
            : []
        ),
        lead_photo: formData.lead_photo || "",
      };

      // console.log("Sending lead data:", leadData)
      // console.log("Disease IDs format:", JSON.stringify(leadData.disease_ids))
      // console.log("Final leadData being sent to service:", JSON.stringify(leadData, null, 2))

      const response = await createLead(leadData);
      // console.log("Lead API response:", response?.data)

      if (
        response?.data?.status === "success" &&
        response?.data?.data?.lead_id
      ) {
        const lead_id = response.data.data.lead_id;

        dispatch({
          type: CONFIRMED_CREATE_LEAD_ACTION,
          payload: response.data.data,
        });

        return {
          success: true,
          lead_id,
          data: response.data.data,
        };
      } else {
        throw new Error(response?.data?.message || "Failed to create lead");
      }
    } catch (error) {
      console.error("Create lead error:", error);
      dispatch({
        type: "FAILED_CREATE_LEAD_ACTION",
        payload: error.message,
      });
      throw error;
    }
  };
}

// Add Marriage Info
export function addleadMarriageInfoAction(marriageData) {
  return async (dispatch) => {
    try {
      // console.log("Marriage Data to send:", marriageData)
      const response = await addLeadMarriageInfo({
        lead_id: marriageData.lead_id,
        is_married: marriageData.is_married,
        marriageHistory:
          marriageData.is_married === "Yes"
            ? JSON.stringify(marriageData.marriage_entries)
            : null,
      });

      // console.log("API raw response:", response)

      if (response?.data) {
        dispatch({
          type: CONFIRMED_ADD_LEAD_MARRIAGE_INFO,
          payload: response.data.data,
        });
        return true;
      }

      throw new Error("Unexpected response format");
    } catch (error) {
      console.error(
        "Marriage Info Error:",
        error.response?.data || error.message
      );
    }
  };
}

// Add Address Info
export function addLeadAddressInfoAction(addressData) {
  return async (dispatch) => {
    try {
      const response = await addLeadAddressInfo({
        lead_id: addressData.lead_id,
        temporaryAddress: addressData.temporary_address,
        permanentAddress: addressData.permanent_address,
      });

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_ADD_LEAD_ADDRESS_INFO,
          payload: response.data.data,
        });
        return true;
      }

      throw new Error("Failed to add address info");
    } catch (error) {
      console.error("Add address info error:", error);
      dispatch({ type: "FAILED_ADD_ADDRESS_INFO", payload: error.message });
      throw error;
    }
  };
}

// Add Other Info
export function addLeadOtherInfoAction(formData, navigate) {
  return async (dispatch) => {
    try {
      // console.log("Submitting Other Info...", formData)

      const response = await addLeadOtherInfo({
        lead_id: formData.lead_id,
        ad_name: formData.ad_name ?? "",
        ad_set: formData.ad_Set ?? "",
        campaign_name: formData.campaign_name ?? "",
        lead_source: formData.lead_source ?? "",
        lead_status: formData.lead_status ?? "",
        lead_type: formData.lead_type ?? "",
        comment: formData.comment ?? "",
        modified_by: formData.modified_by ?? "",
        call_conduct: formData.call_conduct ?? formData.callConduct ?? "",
      });
      console.log("formData.status", formData.lead_status);


      // console.log("Payload sent to addOtherInfo API:", formData)
      // console.log("Response from API:", response?.data)

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_ADD_LEAD_OTHER_INFO,
          payload: response.data.data,
        });

        return { success: true, data: response.data.data };
      }

      throw new Error("Failed to add other info");
    } catch (error) {
      console.error("Add other info error:", error);
      throw error;
    }
  };
}

// Update Lead - Fixed to include lead_id in payload
export function updateLeadAction(formData) {
  return async (dispatch) => {
    try {
      const leadData = {
        lead_id: formData.lead_id, // Added lead_id to the payload
        first_name: formData.first_name,
        middile_name: formData.middle_name || "",
        last_name: formData.last_name,
        email: formData.patient_email || "",
        whatsapp_contact_no: formData.whatsapp_contact_no,
        additional_contact_no: formData.additional_contact_no || "",
        gender: formData.gender,
        date_of_birth: formData.date_of_birth,
        height: formData.height || "",
        weight: formData.weight || "",
        occupation: formData.occupation || "",
        id_proof: formData.id_proof || "",
        id_number: formData.id_number || "",
        disease_ids: JSON.stringify(
          Array.isArray(formData.disease_names)
            ? formData.disease_names
            : formData.disease_names
            ? [formData.disease_names]
            : []
        ),
        lead_photo: formData.lead_photo || "",
      };

      // console.log("Sending lead update data:", JSON.stringify(leadData))
      // console.log("Disease IDs format:", JSON.stringify(leadData.disease_ids))

      const response = await updateLead(leadData);
      // console.log("Lead update API response:", response?.data)

      if (response?.data?.status === "success") {
        const updatedData = {
          ...response.data.data,
          lead_id: response.data.data?.lead_id || leadData.lead_id,
        };

        dispatch({
          type: CONFIRMED_EDIT_LEAD_ACTION,
          payload: updatedData,
        });

        return { lead_id: updatedData.lead_id };
      } else {
        throw new Error(response?.data?.message || "Failed to update lead");
      }
    } catch (error) {
      console.error("Update lead error:", error);
      showErrorAlert( error.message || "Failed to update lead");
      throw error;
    }
  };
}

// Appointment management actions
export function addAppointmentToLeadAction(appointmentData) {
  return {
    type: ADD_APPOINTMENT_TO_LEAD,
    payload: appointmentData,
  };
}

export function updateAppointmentInLeadAction(appointmentData) {
  return {
    type: UPDATE_APPOINTMENT_IN_LEAD,
    payload: appointmentData,
  };
}

export function removeAppointmentFromLeadAction(appointmentId) {
  return {
    type: REMOVE_APPOINTMENT_FROM_LEAD,
    payload: { appointment_id: appointmentId },
  };
}

export const UPDATE_LEAD_BRANCH_REQUEST = "UPDATE_LEAD_BRANCH_REQUEST";
export const UPDATE_LEAD_BRANCH_SUCCESS = "UPDATE_LEAD_BRANCH_SUCCESS";
export const UPDATE_LEAD_BRANCH_FAILURE = "UPDATE_LEAD_BRANCH_FAILURE";

export const updateLeadBranchAction = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: UPDATE_LEAD_BRANCH_REQUEST });

      const response = await axiosInstance.post("/lead/updateLeadBranch", {
        lead_id: payload.lead_id,
        branch_id: payload.branch_id,
      });

      if (response.data.status === "success") {
        dispatch({
          type: UPDATE_LEAD_BRANCH_SUCCESS,
          payload: {
            lead_id: payload.lead_id,
            branch_id: payload.branch_id,
          },
        });

        return response.data;
      } else {
        throw new Error(response.data.message || "Failed to update branch");
      }
    } catch (error) {
      dispatch({
        type: UPDATE_LEAD_BRANCH_FAILURE,
        payload: error.response?.data?.message || "Failed to update branch",
      });
      throw error;
    }
  };
};

